import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackAppPageView } from './appInsights';

export default function TrackPageViews() {
  const location = useLocation();

  useEffect(() => {
    trackAppPageView({
      name: document.title,
      uri: window.location.href,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
